import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { formatCurrency } from 'utils/formatter';

const PaymentForm = ({ planType, amount, clientSecret }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const toast = {};
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {        
        // Make sure to change this to your payment completion page
        return_url: `${location.origin}/app/complete`,
        // navigate('/app/complete', { replace: true }); 
      },
    });
    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === 'card_error' || error.type === 'validation_error') {
      setMessage(error.message);
    } else {
      setMessage('An unexpected error occurred.');
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: 'tabs'
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {/* Show any error or success messages */}
      {message && <Typography variant='h5' color='error' textAlign='center'>{message}</Typography>}
      <Typography variant='subtitle2'>Account: {planType}</Typography>
      <Typography variant='subtitle2'>Payment Amount: {formatCurrency(amount)}</Typography>
      <br/>
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <br/>
      <Button type='submit' variant='contained' color='primary' disabled={isLoading || !stripe || !elements} id="submit" style={{width: '100%'}}>
        <span id="button-text">
          {isLoading ? <CircularProgress /> : 'Pay now'}
        </span>
      </Button>
        
    </form>              
  );    
};

export default PaymentForm;

// useEffect(() => {
//   if (!stripe) {
//     return;
//   }
//   const cs = new URLSearchParams(window.location.search).get(
//     'payment_intent_client_secret'
//   );

//   if (!cs) {
//     return;
//   }

//   stripe.retrievePaymentIntent(cs).then(({ paymentIntent }) => {
//     const toast = {};      
//     switch (paymentIntent.status) {      
//     case 'succeeded':
//       toast.type = 'SUCCESS';
//       toast.message = 'Payment Successful.';
//       setMessage(toast);
//       break;
//     case 'processing':
//       toast.type = 'LOADING';
//       toast.message = 'Processing Payment';
//       setMessage(toast);
//       break;
//     case 'requires_payment_method':
//       toast.type = 'ERROR';
//       toast.message = 'Payment unsuccessful. Please reach out to ChuckTruck support team at info@chucktruck.co';
//       setMessage(toast);
//       break;
//     default:
//       toast.type = 'ERROR';
//       toast.message = 'Payment unsuccesssul. Please reach out to ChuckTruck support team at info@chucktruck.co';
//       setMessage(toast);
//       break;
//     }
//   });
// }, [stripe]);